// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import VueConfig from 'vue-configuration';
import appConfig from './config.js';
import Vuex from 'vuex';
import {ServerTable} from 'vue-tables-2';
import wysiwyg from "vue-wysiwyg";
import VueAxios from 'vue-axios';
import VeeValidate, {Validator} from 'vee-validate';
import Loading from './components/widgets/Loading';
import HighchartsVue from 'highcharts-vue';
import Tree from 'learning-paths-webview';
import utils from '@/utils/utils.js';
import userUtils from '@/utils/userUtils.js';
import VueCookies from 'vue-cookies'
import { directive as onClickOutside } from 'v-click-outside' 
import Buefy from 'buefy'
import AirbnbStyleDatepicker from 'vue-airbnb-style-datepicker';
const VueInputMask = require('vue-inputmask').default

Vue.use(VueCookies)
Vue.use(Tree);
Vue.directive('click-outside', onClickOutside)
Vue.use(HighchartsVue, {tagName: 'charts'})
Vue.use(VueInputMask)
Vue.use(Buefy)

const datepickerOptions = {
  colors: {
    selected: '#174786',
    inRange: '#2368c5',
    selectedText: '#fff',
    text: '#565a5c',
    inRangeBorder: '#174786',
    disabled: '#fff',
    hoveredInRange: '#2368c5'
   }
};
Vue.use(AirbnbStyleDatepicker, datepickerOptions)

require('./css/style.scss')
require('./css/font-awesome/all.min.css')
require('./css/font-awesome/fa-light.min.css')

window.axios = require('axios')

Vue.use(VueAxios, window.axios)
Vue.use(ServerTable);
Vue.component('loading', Loading);

$cookies.config('30d');

const dictionary = {
  en: {
    messages: {
      email: function () {
        return 'Please enter a valid email address.'
      }
    }
  }
};

Validator.localize(dictionary);
Vue.use(VeeValidate);

Vue.use(wysiwyg,
  {
    hideModules: { 'separator': true, 'removeFormat': true },
    image: {
      uploadURL: appConfig.API + '/events/images?fullpath=true',
      dropzoneOptions: {
        maxFilesize: 3
      }
    }
  }
)

Vue.config.productionTip = false

Vue.use(VueConfig, {
  config: appConfig
})

// used to store stuff
Vue.use(Vuex)
const store = new Vuex.Store({
  state: {
    analytics: true,
    active: false,
    attachments: [],
    bookList: [],
    bookListLastAccessPage: {},
    checkActive: false,
    contentToSync: {},
    contentToSyncCounter: 0,
    cookieExpireTime: 0,
    deviceFeatures: {},
    errorLogs: [],
    flashCardHistory: [],
    groups: [],
    highlights: [],
    learningPaths: {
      items: [],
      tags: [],
      userState: []
    },
    loginTime: 0,
    myFolders: [],
    netch: {
      resources: [],
      attachments: [],
      initialized: false
    },
    pdfMemory:{},
    pagesOpened: {},
    resources: [],
    services: [],
    since: 0,
    uniqueId: '', 
    user: {},
    userPreferences: {
      searchResults: [],
      library: {},
      groups: {},
      bookResources: {}
    }
  },
  mutations: {
    updateDeviceFeatures: function (state, features) {
      state.deviceFeatures = features
    },
    updateBookList: function (state, bookList) {
      state.bookList = bookList;
    },
    updateNetch: function (state, netch) {
      var resources = _.find(netch, function(netchItem) {
        return netchItem.key === 'read_res';
      });

      if(resources) {
        resources = resources.value;
      }

      var attachments = _.find(netch, function(netchItem) {
        return netchItem.key === 'read_att';
      });

      if(attachments) {
        attachments = attachments.value;
      }

      // restore dirty netch
      if(state.netch.resources.length > 0) {
        _.each(state.netch.resources, resId => {
          // find resource
          const res = _.find(state.resources, res => res._id === resId);
          // if it is dirty, update new netch state
          if(res && res.isReadDirty === false) {
            // filter out unread
            resources = _.filter(resources, resToFilter => resToFilter._id !== res._id);
          } else if(res && res.isReadDirty === true) {
            // add read
            resources.push(res._id);
          }
        });
        
        _.each(state.netch.attachments, attId => {
          // find attachment
          const att = _.find(state.attachments, att => att._id === attId);
          // if it is dirty, update new netch state
          if(att && att.isReadDirty === false) {
            // filter out unread
            attachments = _.filter(attachments, attToFilter => attToFilter._id !== att._id);
          } else if(att && att.isReadDirty === true) {
            // add read
            attachments.push(att._id);
          }
        });
      }

      state.netch.resources = _.uniq(resources);
      state.netch.attachments = _.uniq(attachments);
      state.netch.initialized = true;
    },
    updatePagesOpened: function (state, pagesOpened) {
      const pagesOpenedLocally = state.pagesOpened;
      
      // key it by book
      var pagesOpenedFromServer = _.keyBy(pagesOpened, 'book');
      // key each page by the pageIndex
      _.each(pagesOpenedFromServer, function(bookAndPages) {
        bookAndPages.pages = _.keyBy(bookAndPages.pages, 'pageIndex');
      });

      // ensure that old bookPages are still kept if they are not in the data from the server
      // this is for the temporary state of a page being opened, but the server not yet figuring that out
      _.each(pagesOpenedLocally, function(localBookAndPages) {
        const serverBookAndPages = pagesOpenedFromServer[localBookAndPages.book];
        // if the server doesn't know about the book yet, add it to the local state
        if(!serverBookAndPages) {
          pagesOpenedFromServer[localBookAndPages.book] = localBookAndPages;
        } else {
          // otherwise go through each page and check whether it is present
          _.each(localBookAndPages, function(page) {
            if(!serverBookAndPages[page.pageIndex]) {
              serverBookAndPages[page.pageIndex] = page;
            }
          });
        }
      });
      
      state.pagesOpened = pagesOpenedFromServer;
    },
    restoreContentFromIndexedDB: function(state, content) {
      for(var key in content) state[key] = content[key];
    },
    updateContent: function (state, content) {
      var resources = _.filter(content.resources, res => !res.deleted);
      var attachments = _.filter(content.attachments, att => !att.deleted);

      // update is read statusses
      var netch = state.netch;

      try {
        _.each(resources, function (resource) {
          if (netch.resources) {
            resource.isRead = netch.resources.indexOf(resource._id) >= 0;

            // remove dirtyness if it is legitly now in netch from the server
            if (resource.isRead) {
              resource.isReadDirty = false;
            }
          } else {
            resource.isRead = false;
          }
        })  
      } catch (error) {
        console.error("Could not update resources:", error)
      }

      try {
        _.each(attachments, function (attachment) {
          if (netch.attachments) {
            attachment.isRead = netch.attachments.indexOf(attachment._id) >= 0;
            // remove dirtyness if it is legitly now in netch from the server
            if (attachment.isRead) {
              attachment.isReadDirty = false;
            }
          } else {
            attachment.isRead = false;
          }
        });  
      } catch (error) {
        console.error("Could not update attachments", error)
      }
      
      try {
        const annotationsRaw = _.filter(content.annotations.items, annot => !annot.deleted);
        _.each(annotationsRaw, annot => {
          if (annot && annot.data && annot._id) {
            annot.data = annot.data.replace(/\r?\n|\r/g, ''); // remove all new line characters
            var annotation = JSON.parse(annot.data);
            annotation._id = annot._id;

            if (!annotation._id) {
              return; // exclude annotations without ids
            }

            // create an attachment for each annotation attachment
            _.each(annotation.attachments, function (att) {
              att.resource = annotation._id;
              att._id = att.id;
              attachments.push(att);
            });

            delete annotation.attachments;

            if (annotation.type == "wmgc.mobi.content.resources.SketchAnnotation") {
              annotation.category = "sketch"
            } else if (annotation.type == "wmgc.mobi.content.resources.NoteAnnotation") {
              annotation.category = "note"
              if (annotation.title.length === 0) {
                annotation.title = "Empty Note";
              }
            } else if (annotation.type == "wmgc.mobi.content.resources.GoogleDriveAnnotation") {
              annotation.category = "googledrive"
            } else if (annotation.type == "wmgc.mobi.content.resources.DrawingAnnotation") {
              annotation.category = "drawing"
            }

            // add the annotation as a resource
            resources.push(annotation);
          }
        });
      } catch (error) {
        console.log("Could not update annotations:", error)
      }
      
      try {
        content.learningPaths.items = _.filter(content.learningPaths.items, item => !item.deleted);
        content.learningPaths.tags = _.filter(content.learningPaths.tags, tag => !tag.deleted);

        if (state.since === 0) {
          state.since = Math.floor(Date.now() / 1000) - 30;
          state.bookList = content.bookList.items;
          state.flashCardHistory = content.flashCardHistory.items;
          state.highlights = content.highlights.items;
          state.services = content.services.items;
          state.myFolders = content.myFolders.items;
          state.learningPaths = content.learningPaths;
          state.resources = resources;
          state.attachments = attachments;
          state.groups = content.groups
        } else {
          var t = this;
          state.since = Math.floor(Date.now() / 1000) - 30;
          state.bookList = content.bookList.items;
          state.learningPaths = content.learningPaths;
          state.groups = content.groups
  
          _.each(content.flashCardHistory.items, item => {
            var index = _.findIndex(state.flashCardHistory, i => {
              return i.resource === item.resource
            })
            if (index !== -1) {
              state.flashCardHistory[sessions] = item.sessions;
            } else {
              state.flashCardHistory.push(item);
            }
          })
  
          _.each(content.highlights.items, item => {
            var index = _.findIndex(state.highlights, i => {
              return i._id === item._id
            })
            if (index !== -1) {
              state.highlights[index] = item;
            } else {
              state.highlights.push(item);
            }
          })
  
          _.each(content.annotations.items, item => {
            var drawingResForPage = JSON.parse(item.data);
            var drawingAttForPage = drawingResForPage.attachments;
            delete drawingResForPage.attachments;
  
            drawingResForPage.category = "drawing";
            drawingResForPage._id = drawingResForPage.id;
            
            var resIndex = _.findIndex(state.resources, i => {
              return i.id === drawingResForPage.id
            })
            if (resIndex !== -1) {
              state.resources[resIndex] = drawingResForPage;
            } else {
              state.resources.push(drawingResForPage);
            }
            
            _.each(drawingAttForPage, att => {
              att.resource = drawingResForPage.id;
              att._id = att.id;
              var attIndex = _.findIndex(state.attachments, i => {
                return i._id === att._id
              })
    
              if (attIndex !== -1) {
                state.attachments[attIndex] = att;
              } else {
                state.attachments.push(att);
              }
            })
          })
  
          _.each(content.services.items, item => {
            var index = _.findIndex(state.services, i => {
              return i.id === item.id
            })
            if (index !== -1) {
              state.services[index] = item;
            } else {
              state.services.push(item);
            }
          })
  
          _.each(content.myFolders.items, item => {
            var index = _.findIndex(state.myFolders, i => {
              return i.group === item.group
            })
            if (index !== -1) {
              state.myFolders[index] = item;
            } else {
              state.myFolders.push(item);
            }
          })
  
          _.each(content.resources, item => {
            var index = _.findIndex(state.resources, i => {
              return i._id === item._id
            })
            if (index !== -1) {
              state.resources[index] = item;
            } else {
              state.resources.push(item);
            }
          })
  
          _.each(content.attachments, item => {
            var index = _.findIndex(state.attachments, i => {
              return i._id === item._id
            })
            if (index !== -1) {
              state.attachments[index] = item;
            } else {
              state.attachments.push(item);
            }
          })
        }
      } catch (error) {
        console.error("Could not update since data:", error)
      }
    },
    syncItem: function (state, syncObject) {
      syncObject.unsuccessfulAttempts = 0;
      state.contentToSync[state.contentToSyncCounter++] = syncObject;
    },
    removeItemToSync: function (state, index) {
      state.contentToSyncCounter++; // to update loader
      delete state.contentToSync[index];
    },
    updateUser: function (state, user) {
      state.user = user;
    },
    updateUniqueId: function (state, uniqueId) {
      state.uniqueId = uniqueId;
    },
    addErrorLog: function (state, errorLog) {
      state.errorLogs.push(errorLog);
    },
    clearErrorLogs: function(state) {
      state.errorLogs = [];
    }
  }
})

window.app = new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { 'App': App},
  watch: {
    '$route': 'checkLogin'
  },
  store,
  methods: {
    checkLogin: function () {
      var t = this;
      
      var userCookie = userUtils.getCookie('user');
      var uniqueId = userUtils.getCookie('aid');
      var user = (userCookie ? userCookie : {});

      if(!t.$config.get('localServer')) {
        axios.defaults.headers.common['X-Auth-Mechanism'] = 'no-basic';
      }
      
      if (user && user.cookieToken) {      
        axios.defaults.headers.common['Authorization'] = 'JWT ' + user.cookieToken;
      } 

      if (!uniqueId) {
        uniqueId = 'web-' + utils.GUID();
        userUtils.setCookie('aid', uniqueId);
      }

      t.$store.commit('updateUniqueId', uniqueId);
      t.$store.commit('updateUser', user);    
    }
  },
  created: function () {
    this.checkLogin();
  }
});
